import { useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import type { CreateOrderType, OrderType } from '@klareospace/pharos-lib-types';
import { createMutationCallbacks } from '@klareospace/pharos-lib-web-utils';

import { createOrderTypeApi, orderTypeKeys } from '../api';

export function useCreateOrderType(): UseMutationResult<OrderType, Error, CreateOrderType> {
  const client = useApiClient('admin-auth');
  const api = createOrderTypeApi(client);
  const queryClient = useQueryClient();
  const { t } = useTranslation('settings');

  return useMutation<OrderType, Error, CreateOrderType>({
    mutationFn: (data: CreateOrderType) => api.createOrderType(data),
    ...createMutationCallbacks({
      invalidateKeys: [orderTypeKeys.all],
      queryClient,
      successKey: 'orderTypes.actions.create.success',
      t,
    }),
  });
}
